export const ROUTES = {
  LOGIN: 'prijava',
  REGISTER: 'registracija',
  PASSWORD_RECOVERY: 'obnova-lozinke',
  PASSWORD_RECOVERY_SUBMIT: 'obnova-lozinke-potvrda',
  MAINTENANCE: 'održavanje',
  VERIFICATION: 'verifikacija',
  FOUR_ZERO_FOUR: '404',
  NOT_FOUND: 'not-found',
  HOME: 'početna',
  HOME_CAFE: 'max-cafe',
  HOME_BETTING: 'betting',
  BETTING_TASKS: 'betting-zadaci',
  BETTING_JACKPOT: 'jackpot',
  PROFILE: 'profil',
  PROMO: 'promocije',
  QR_SCANNER: 'qr-kod',
  QR_SCANNER_CAMERA: 'kamera',
  QR_SCANNER_MANUAL_ENTRY: 'manuelni-unos',
  QR_SCANNER_MANUAL_ENTRY_FULL_PATH: 'qr-kod/manuelni-unos',

  BAR_CODE: 'kartica',

  MY_PROFILE: 'detalji',
  TRANSACTION_HISTORY: 'transakcije',
  GAME_RULES: 'pravila-igre',
  ABOUT_APP: 'o-aplikaciji',
  TERMS_AND_CONDITIONS: 'uslovi-i-politika-privatnosti',
  LOGIN_ABOUT_APP: 'o_aplikaciji',
  SUPPORT: 'korisnicka-podrska',

  FREE_TO_PLAY: 'free-to-play',
  FREE_TO_PLAY_TICKETS_DETAILS: 'detalji-tiketa/:id/:status',
  FREE_TO_PLAY_TICKETS_DETAILS_FULL_PATH: 'free-to-play/detalji-tiketa',

  МАX_SHOP: 'max-prodavnica',
  МАX_SHOP_ADD_TO_CART: 'dodaj-u-korpu/:id',
  МАX_SHOP_ORDER_DETAILS: 'detalji-porudzbine/:id',

  МАX_SHOP_ADD_TO_CART_FULL_PATH: 'max-prodavnica/dodaj-u-korpu',
  МАX_SHOP_ORDER_DETAILS_FULL_PATH: 'max-prodavnica/detalji-porudzbine',

  МАX_SHOP_MY_CART: 'moja-korpa',
  МАX_SHOP_SHIPPING_DATA: 'podaci-za-slanje',
  МАX_SHOP_CONFIRM_SHIPPING: 'potvrda-za-slanje',

  МАX_VOUCHERS: 'max-vaučeri',
  PURCHSED_MBC_VOUCHER_DETAILS: 'detalji-kupljenog-mbc-vaučera/:id',
  AVAILABLE_MBC_VOUCHER_DETAILS: 'detalji-mbc-vaučera/:id',
  PURCHSED_PRODUCT_VOUCHER_DETAILS: 'detalji-kupljenog-robnog-vaučera/:id',
  AVAILABLE_PRODUCT_VOUCHER_DETAILS: 'detalji-robnog-vaučera/:id',

  PURCHSED_MBC_VOUCHER_DETAILS_FULL_PATH:
    'max-vaučeri/detalji-kupljenog-mbc-vaučera',
  AVAILABLE_MBC_VOUCHER_DETAILS_FULL_PATH: 'max-vaučeri/detalji-mbc-vaučera',

  PURCHSED_PRODUCT_VOUCHER_DETAILS_FULL_PATH:
    'max-vaučeri/detalji-kupljenog-robnog-vaučera',
  AVAILABLE_PRODUCT_VOUCHER_DETAILS_FULL_PATH:
    'max-vaučeri/detalji-robnog-vaučera',
};
